import InitGame from "./game/InitGame.svelte";
import ScoreKeeping from "./game/ScoreKeeping.svelte";

export default [
    {
        path: '/',
        name: 'Home',
        component: InitGame,
    },
    {
        path: '/score',
        name: 'Score',
        component: ScoreKeeping,
    }
]